export const ERROR_CODE_INVALID_TOKEN = 112
export const FORBIDDEN_CODE = 403
